import React, { useState, useEffect } from "react";
import { useTranslation } from 'react-i18next';
import '../../CSS/Visiter.css';
import BeninInfo from "../composant_reutilisable/BeninInfo";
import Carousel from "../composant_reutilisable/Carousel";
import Africa from '../../images/Africa.svg';
import pr from '../../images/vodun.png';
import voyage from '../../images/voyage.png';
import voyage1 from '../../images/senum.png';
import ouidah from '../../images/ouidah.png';
import MenuSection from "./menuSection";
import { useLanguageData } from '../../hooks/useLanguageData';
import SafeHTML from "../SafeHTML";

const Galery = () => {
    const { t } = useTranslation();
    
    // Données d'exemple pour la galerie
    const galleryItems = [
        {
            id: 1,
            type: 'image',
            src: voyage,
            title: 'Voyage au Bénin',
            description: 'Découverte des paysages béninois'
        },
        {
            id: 2,
            type: 'image',
            src: pr,
            title: 'Culture béninoise',
            description: 'Arts et traditions'
        },
        {
            id: 3,
            type: 'image',
            src: voyage1,
            title: 'Événement diplomatique',
            description: 'Rencontre officielle'
        },
        
        {
            id: 4,
            type: 'image',
            src: Africa,
            title: 'Carte de l\'Afrique',
            description: 'Position géographique du Bénin'
        },
        {
            id: 5,
            type: 'video',
            src: 'https://www.youtube.com/embed/YGo7dl4IgnM?si=JaKgf52RzEhuNyld',
            title: 'Vidéo culturelle',
            description: 'Traditions et danses'
        },
        {
            id: 6,
            type: 'image',
            src: ouidah,
            title: 'Ouidah',
            description: 'Porte du non retour'
        }
    ];

    return (
        <div className="visiter-container mt-4">
            <div className="visiter-content">
                {/* <MenuSection title={t('visiterChine.galery')} showSubtitles={false} /> */}

                {/* Section Galerie */}
                <div className="gallery-section">
                    <div className="gallery-grid">
                        {galleryItems.map((item) => (
                            <div key={item.id} className="gallery-item">
                                {item.type === 'image' ? (
                                    <div className="gallery-image-wrapper">
                                        <img 
                                            src={item.src} 
                                            alt={item.title}
                                            className="gallery-image"
                                            loading="lazy"
                                        />
                                        <div className="gallery-overlay">
                                            <div className="gallery-overlay-content">
                                                <h3 className="gallery-item-title">{item.title}</h3>
                                                <p className="gallery-item-description">{item.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    <div className="gallery-video-wrapper">
                                        <iframe
                                            src={item.src}
                                            title={item.title}
                                            className="gallery-video"
                                            frameBorder="0"
                                            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                            allowFullScreen
                                        ></iframe>
                                        <div className="gallery-overlay">
                                            <div className="gallery-overlay-content">
                                                <h3 className="gallery-item-title">{item.title}</h3>
                                                <p className="gallery-item-description">{item.description}</p>
                                            </div>
                                        </div>
                                    </div>
                                )}
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {/* Styles */}
            <style jsx>{`
                .loading-container, .error-container {
                    display: flex;
                    flex-direction: column;
                    align-items: center;
                    justify-content: center;
                    padding: 2rem;
                    text-align: center;
                    min-height: 200px;
                    width: 100%;
                    grid-column: 1 / -1;
                }

                .loading-spinner {
                    width: 40px;
                    height: 40px;
                    border: 4px solid #f3f3f3;
                    border-top: 4px solid #1a3c5e;
                    border-radius: 50%;
                    animation: spin 1s linear infinite;
                    margin-bottom: 1rem;
                }

                .error-container {
                    max-width: 700px;
                    width: 100%;
                }

                .error-icon {
                    font-size: 3rem;
                    margin-bottom: 1rem;
                }

                .error-container h3 {
                    color: #d32f2f;
                    margin-bottom: 0.5rem;
                    font-size: 1.5rem;
                }

                .error-container p {
                    color: #666;
                    margin: 0;
                }

                @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                }

                .voyage-description p {
                    margin: 0;
                    display: inline;
                }

                /* Styles de la galerie */
                .gallery-section {
                    padding: 40px 20px;
                    
                    margin: 0 auto;
                }

                .gallery-grid {
                    display: grid;
                    grid-template-columns: repeat(auto-fill, minmax(300px, 1fr));
                    gap: 25px;
                }

                .gallery-item {
                    position: relative;
                    border-radius: 12px;
                    overflow: hidden;
                    box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
                    transition: transform 0.3s ease, box-shadow 0.3s ease;
                    background: #f8f9fa;
                    aspect-ratio: 4/3;
                }

                .gallery-item:hover {
                    transform: translateY(-5px);
                    box-shadow: 0 8px 25px rgba(0, 0, 0, 0.2);
                }

                .gallery-image-wrapper,
                .gallery-video-wrapper {
                    width: 100%;
                    height: 100%;
                    position: relative;
                    overflow: hidden;
                }

                .gallery-image {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                    transition: transform 0.5s ease;
                }

                .gallery-item:hover .gallery-image {
                    transform: scale(1.05);
                }

                .gallery-video {
                    width: 100%;
                    height: 100%;
                    border: none;
                }

                /* Overlay au survol */
                .gallery-overlay {
                    position: absolute;
                    bottom: 0;
                    left: 0;
                    right: 0;
                    background: linear-gradient(to top, rgba(10, 44, 87, 0.9), rgba(10, 44, 87, 0));
                    padding: 30px 20px 20px;
                    transform: translateY(100%);
                    transition: transform 0.3s ease;
                    display: flex;
                    align-items: flex-end;
                }

                .gallery-item:hover .gallery-overlay {
                    transform: translateY(0);
                }

                .gallery-overlay-content {
                    color: white;
                    width: 100%;
                }

                .gallery-item-title {
                    font-size: 1.1rem;
                    font-weight: 600;
                    margin: 0 0 5px 0;
                    color: white;
                }

                .gallery-item-description {
                    font-size: 0.9rem;
                    margin: 0;
                    opacity: 0.9;
                    color: rgba(255, 255, 255, 0.9);
                }

                /* Badge pour différencier images et vidéos */
                .gallery-item::before {
                    content: '';
                    position: absolute;
                    top: 10px;
                    right: 10px;
                    z-index: 2;
                    background: rgba(0, 0, 0, 0.6);
                    color: white;
                    padding: 4px 10px;
                    border-radius: 20px;
                    font-size: 0.75rem;
                    font-weight: 500;
                    pointer-events: none;
                }

                /* Responsive */
                @media (max-width: 992px) {
                    .gallery-grid {
                        grid-template-columns: repeat(auto-fill, minmax(280px, 1fr));
                        gap: 20px;
                    }
                }

                @media (max-width: 768px) {
                    .gallery-section {
                        padding: 30px 15px;
                    }

                    .gallery-grid {
                        grid-template-columns: repeat(auto-fill, minmax(250px, 1fr));
                        gap: 15px;
                    }

                    .gallery-item {
                        aspect-ratio: 4/3;
                    }

                    .gallery-overlay {
                        transform: translateY(0);
                        background: linear-gradient(to top, rgba(10, 44, 87, 0.8), rgba(10, 44, 87, 0.1));
                        padding: 20px 15px 15px;
                    }

                    .gallery-item-title {
                        font-size: 1rem;
                    }

                    .gallery-item-description {
                        font-size: 0.8rem;
                    }
                }

                @media (max-width: 480px) {
                    .gallery-grid {
                        grid-template-columns: 1fr;
                        gap: 15px;
                    }

                    .gallery-item {
                        aspect-ratio: 16/9;
                    }

                    .gallery-section {
                        padding: 20px 10px;
                    }
                }
            `}</style>
        </div>
    );
};

export default Galery;